import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Chip } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";

const HomeSectionsTableRow = ({
    section,
    index,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen
}) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';

    const getStatusLabel = (isActive) => {
        if (isActive) return { label: isArabic ? 'نشط' : 'Active', color: 'success' };
        return { label: isArabic ? 'غير نشط' : 'Inactive', color: 'default' };
    };

    const status = getStatusLabel(section.is_active);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, section.id)}
                />
            </TableCell>

            <TableCell align="center">{index + 1}</TableCell>

            <TableCell>
                <Typography variant="body2">{section.title?.en || '-'}</Typography>
            </TableCell>

            <TableCell>
                <Typography variant="body2">{section.title?.ar || '-'}</Typography>
            </TableCell>

            <TableCell align="center">
                <Chip label={section.type} size="small" variant="outlined" />
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                    {section.code}
                </Typography>
            </TableCell>

            <TableCell align="center">
                <Chip
                    label={status.label}
                    color={status.color}
                    size="small"
                />
            </TableCell>

            <TableCell>
                {dayjs(section.created_at).format("YYYY-MM-DD")}
            </TableCell>

            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, section)}>
                    <MoreVert />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default HomeSectionsTableRow;
